export interface TimeRangeConfig {
  minTimestamp: number;
  maxTimestamp: number;
}

export enum TimeRangeEvents {
  TIME_RANGE_CHANGE = 'time-range-change',
}
